import PropTypes from 'prop-types'
import '../styles/tailwind.css'

import { isAuthenticated, redirectTo } from '_helpers/authHelper'
import AuthProvider from '../authContext'

const PlusApp = ({ Component, pageProps }) => (
  <AuthProvider>
    <Component {...pageProps} />
  </AuthProvider>
)

PlusApp.getInitialProps = async ({ ctx }) => {
  const { asPath, pathname, res, req } = ctx

  const isLogin = await isAuthenticated(req)
  if (pathname !== '/login' && !isLogin) {
    redirectTo(`/login?redirectUrl=${asPath}`, { res })
  }

  return {}
}

PlusApp.propTypes = {
  Component: PropTypes.func,
  pageProps: PropTypes.object,
}

export default PlusApp
